package com.pincer.client

import com.pincer.core.Logger
import com.pincer.core.PincerException
import com.pincer.core.contracts.StringContract
import io.ktor.client.*
import io.ktor.client.engine.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.*

class StringContractFromHttp(
    val server: String,
    val engine: HttpClientEngine? = null,
): StringContract {

    private val log = Logger()

    override suspend fun process(string: String): String {
        //log.f("Request: $string")
        val httpClient = if (engine == null) HttpClient() else HttpClient(engine)
        val httpResponse: HttpResponse = httpClient.request("$server/v1/request") {
            method = HttpMethod.Post
            headers {
                append("Content-Type", "application/json")
                append("Accept", "application/json")
            }
            setBody(string)
        }
        httpClient.close()
        val response = httpResponse.bodyAsText()
        //log.f("Response: $response")
        return response
    }

}
